// Generated by purs version 0.13.8
"use strict";
var CSS_String = require("../CSS.String/index.js");
var Color = require("../Color/index.js");
var Control_Alternative = require("../Control.Alternative/index.js");
var Control_Category = require("../Control.Category/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_NonEmpty = require("../Data.NonEmpty/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Prefixed = (function () {
    function Prefixed(value0) {
        this.value0 = value0;
    };
    Prefixed.create = function (value0) {
        return new Prefixed(value0);
    };
    return Prefixed;
})();
var Plain = (function () {
    function Plain(value0) {
        this.value0 = value0;
    };
    Plain.create = function (value0) {
        return new Plain(value0);
    };
    return Plain;
})();
var Value = function (x) {
    return x;
};
var Literal = function (x) {
    return x;
};
var Key = function (x) {
    return x;
};
var Val = function (value) {
    this.value = value;
};
var value = function (dict) {
    return dict.value;
};
var valValue = new Val(Control_Category.identity(Control_Category.categoryFn));
var semigroupPrefixed = new Data_Semigroup.Semigroup(function (v) {
    return function (v1) {
        if (v instanceof Plain && v1 instanceof Plain) {
            return Plain.create(v.value0 + v1.value0);
        };
        if (v instanceof Plain && v1 instanceof Prefixed) {
            return Prefixed.create(Data_Functor.map(Data_Functor.functorArray)(Data_Profunctor_Strong.second(Data_Profunctor_Strong.strongFn)(function (v2) {
                return v.value0 + v2;
            }))(v1.value0));
        };
        if (v instanceof Prefixed && v1 instanceof Plain) {
            return Prefixed.create(Data_Functor.map(Data_Functor.functorArray)(Data_Profunctor_Strong.second(Data_Profunctor_Strong.strongFn)(function (v2) {
                return v1.value0 + v2;
            }))(v.value0));
        };
        if (v instanceof Prefixed && v1 instanceof Prefixed) {
            return Prefixed.create(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v.value0)(v1.value0));
        };
        throw new Error("Failed pattern match at CSS.Property (line 25, column 1 - line 29, column 59): " + [ v.constructor.name, v1.constructor.name ]);
    };
});
var semigroupValue = new Data_Semigroup.Semigroup(function (v) {
    return function (v1) {
        return Value(Data_Semigroup.append(semigroupPrefixed)(v)(v1));
    };
});
var quote = function (s) {
    return "\"" + (s + "\"");
};
var plain = function (v) {
    if (v instanceof Prefixed) {
        return Data_Maybe.fromMaybe("")(Data_Tuple.lookup(Data_Foldable.foldableArray)(Data_Eq.eqString)("")(v.value0));
    };
    if (v instanceof Plain) {
        return v.value0;
    };
    throw new Error("Failed pattern match at CSS.Property (line 34, column 1 - line 34, column 28): " + [ v.constructor.name ]);
};
var monoidPrefixed = new Data_Monoid.Monoid(function () {
    return semigroupPrefixed;
}, new Plain(Data_Monoid.mempty(Data_Monoid.monoidString)));
var monoidValue = new Data_Monoid.Monoid(function () {
    return semigroupValue;
}, Data_Monoid.mempty(monoidPrefixed));
var isStringPrefixed = new CSS_String.IsString(Plain.create);
var isStringValue = new CSS_String.IsString((function () {
    var $123 = CSS_String.fromString(isStringPrefixed);
    return function ($124) {
        return Value($123($124));
    };
})());
var noCommas = function (dictVal) {
    var $125 = Data_Foldable.intercalate(Data_Foldable.foldableArray)(monoidValue)(CSS_String.fromString(isStringValue)(" "));
    return function ($126) {
        return $125((function (v) {
            return Data_Functor.map(Data_Functor.functorArray)(value(dictVal))(v);
        })($126));
    };
};
var valColor = new Val((function () {
    var $127 = CSS_String.fromString(isStringValue);
    return function ($128) {
        return $127(Color.cssStringHSLA($128));
    };
})());
var valList = function (dictVal) {
    return new Val((function () {
        var $129 = Data_Foldable.intercalate(Data_Foldable.foldableArray)(monoidValue)(CSS_String.fromString(isStringValue)(", "));
        return function ($130) {
            return $129((function (v) {
                return Data_Functor.map(Data_Functor.functorArray)(value(dictVal))(v);
            })($130));
        };
    })());
};
var valNonEmpty = function (dictVal) {
    return new Val((function () {
        var $131 = value(valList(dictVal));
        var $132 = Data_NonEmpty.oneOf(Control_Alternative.alternativeArray);
        return function ($133) {
            return $131($132($133));
        };
    })());
};
var valLiteral = new Val(function (v) {
    return CSS_String.fromString(isStringValue)(quote(v));
});
var valNumber = new Val((function () {
    var $134 = CSS_String.fromString(isStringValue);
    var $135 = Data_Show.show(Data_Show.showNumber);
    return function ($136) {
        return $134($135($136));
    };
})());
var valString = new Val(CSS_String.fromString(isStringValue));
var valTuple = function (dictVal) {
    return function (dictVal1) {
        return new Val(function (v) {
            return Data_Semigroup.append(semigroupValue)(value(dictVal)(v.value0))(Data_Semigroup.append(semigroupValue)(CSS_String.fromString(isStringValue)(" "))(value(dictVal1)(v.value1)));
        });
    };
};
var valUnit = new Val(function (u) {
    return CSS_String.fromString(isStringValue)("");
});
var isStringKey = new CSS_String.IsString((function () {
    var $137 = CSS_String.fromString(isStringPrefixed);
    return function ($138) {
        return Key($137($138));
    };
})());
var genericValue = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericPrefixed = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Prefixed) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof Plain) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at CSS.Property (line 20, column 1 - line 20, column 54): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new Prefixed(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new Plain(x.value0);
    };
    throw new Error("Failed pattern match at CSS.Property (line 20, column 1 - line 20, column 54): " + [ x.constructor.name ]);
});
var genericLiteral = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericKey = function (dictGeneric) {
    return new Data_Generic_Rep.Generic(function (x) {
        return x;
    }, function (x) {
        return x;
    });
};
var eqPrefixed = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Prefixed && y instanceof Prefixed) {
            return Data_Eq.eq(Data_Eq.eqArray(Data_Tuple.eqTuple(Data_Eq.eqString)(Data_Eq.eqString)))(x.value0)(y.value0);
        };
        if (x instanceof Plain && y instanceof Plain) {
            return x.value0 === y.value0;
        };
        return false;
    };
});
var eqValue = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(eqPrefixed)(x)(y);
    };
});
var ordPrefixed = new Data_Ord.Ord(function () {
    return eqPrefixed;
}, function (x) {
    return function (y) {
        if (x instanceof Prefixed && y instanceof Prefixed) {
            return Data_Ord.compare(Data_Ord.ordArray(Data_Tuple.ordTuple(Data_Ord.ordString)(Data_Ord.ordString)))(x.value0)(y.value0);
        };
        if (x instanceof Prefixed) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Prefixed) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof Plain && y instanceof Plain) {
            return Data_Ord.compare(Data_Ord.ordString)(x.value0)(y.value0);
        };
        throw new Error("Failed pattern match at CSS.Property (line 19, column 1 - line 19, column 44): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var ordValue = new Data_Ord.Ord(function () {
    return eqValue;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(ordPrefixed)(x)(y);
    };
});
var eqLiteral = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x === y;
    };
});
var ordLiteral = new Data_Ord.Ord(function () {
    return eqLiteral;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(Data_Ord.ordString)(x)(y);
    };
});
var eqKey = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            return Data_Eq.eq(eqPrefixed)(x)(y);
        };
    });
};
var ordKey = function (dictOrd) {
    return new Data_Ord.Ord(function () {
        return eqKey(dictOrd.Eq0());
    }, function (x) {
        return function (y) {
            return Data_Ord.compare(ordPrefixed)(x)(y);
        };
    });
};
var cast = function (v) {
    return v;
};
module.exports = {
    value: value,
    Prefixed: Prefixed,
    Plain: Plain,
    plain: plain,
    quote: quote,
    Key: Key,
    cast: cast,
    Value: Value,
    Val: Val,
    Literal: Literal,
    noCommas: noCommas,
    eqPrefixed: eqPrefixed,
    ordPrefixed: ordPrefixed,
    genericPrefixed: genericPrefixed,
    isStringPrefixed: isStringPrefixed,
    semigroupPrefixed: semigroupPrefixed,
    monoidPrefixed: monoidPrefixed,
    eqKey: eqKey,
    ordKey: ordKey,
    genericKey: genericKey,
    isStringKey: isStringKey,
    eqValue: eqValue,
    ordValue: ordValue,
    genericValue: genericValue,
    isStringValue: isStringValue,
    semigroupValue: semigroupValue,
    monoidValue: monoidValue,
    eqLiteral: eqLiteral,
    ordLiteral: ordLiteral,
    genericLiteral: genericLiteral,
    valLiteral: valLiteral,
    valValue: valValue,
    valString: valString,
    valUnit: valUnit,
    valTuple: valTuple,
    valNumber: valNumber,
    valList: valList,
    valNonEmpty: valNonEmpty,
    valColor: valColor
};
